import {FC} from 'react'
import {Accordion, Button, Card, Dropdown, Form} from 'react-bootstrap'

export type SettingsValue = {
  year: number
  elasSupply: number
  elasSubstitution: number
  elasType: 1 | 2
}

type Props = {
  availableYears: number[]
  value: SettingsValue
  onChange: (v: SettingsValue) => void
  onSubmit: () => void
  submitDisabled: boolean
}

const SimulationSettings: FC<Props> = ({
  availableYears,
  value,
  onChange,
  onSubmit,
  submitDisabled,
}) => {
  const set = (patch: Partial<SettingsValue>) => onChange({...value, ...patch})

  return (
    <Card
      className='sticky-top'
      style={{top: 'calc(var(--bs-app-header-height, 70px) + 20px)'}}
    >
      <Card.Header className='card-header-stretch'>
        <Card.Title>
          <span className='fa fa-gear px-2'></span>
          <h3 className='text-gray-700'>Settings for the simulation</h3>
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Form.Group className='mb-6'>
          <Form.Label className='text-primary'>Import data year</Form.Label>
          <Dropdown>
            <Dropdown.Toggle variant='label-dropdown' className='btn btn-sm w-100 text-start'>
              {value.year || 'Select year'}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {availableYears.map((y) => (
                <Dropdown.Item key={y} onClick={() => set({year: y})}>
                  {y}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </Form.Group>

        <Accordion className='mb-6'>
          <Accordion.Item eventKey='0'>
            <Accordion.Header>Show advanced simulation settings</Accordion.Header>
            <Accordion.Body>
              <Form.Group className='mb-4'>
                <Form.Label className='text-primary'>Supply elasticity</Form.Label>
                <Form.Control
                  type='number'
                  size='sm'
                  value={value.elasSupply}
                  onChange={(e) => set({elasSupply: +e.target.value})}
                />
              </Form.Group>
              <Form.Group className='mb-4'>
                <Form.Label className='text-primary'>Substitution elasticity</Form.Label>
                <Form.Control
                  type='number'
                  size='sm'
                  value={value.elasSubstitution}
                  onChange={(e) => set({elasSubstitution: +e.target.value})}
                />
              </Form.Group>
              <Form.Group>
                <Form.Label className='text-primary'>Import demand elasticity</Form.Label>
                <Button
                  variant=''
                  className={`btn btn-radio w-100 btn-sm fw-bold mb-2 ${
                    value.elasType === 1
                      ? 'btn-primary text-white'
                      : 'btn-outline btn-outline-primary'
                  }`}
                  onClick={() => set({elasType: 1})}
                >
                  Utokthamm, Kravchenko and Duval (2020)
                </Button>
                <Button
                  variant=''
                  className={`btn btn-radio w-100 btn-sm fw-bold ${
                    value.elasType === 2
                      ? 'btn-primary text-white'
                      : 'btn-outline btn-outline-primary'
                  }`}
                  onClick={() => set({elasType: 2})}
                >
                  Kee, Nicita and Olarreaga (2008)
                </Button>
              </Form.Group>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        <Button
          className='w-100 btn btn-warning text-black fw-bold'
          disabled={submitDisabled}
          onClick={onSubmit}
        >
          Submit &amp; Simulate <span className='fa-solid fa-angles-right px-1'></span>
        </Button>
      </Card.Body>
    </Card>
  )
}

export default SimulationSettings
